import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@mui/material';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ActiveFilterRound = function ActiveFilterRound(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 9 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#FF5100' : _ref$color,
    additionalStyles = _ref.additionalStyles;
  return /*#__PURE__*/_jsx(Box, {
    sx: _objectSpread({
      width: size,
      height: size,
      borderRadius: '50%',
      backgroundColor: color
    }, additionalStyles)
  });
};
export default ActiveFilterRound;